__turbopack_context__.v({
  "img": "PlasmicHeader-module__d6lisG__img",
  "imgglobal_themeOrange_override": "PlasmicHeader-module__d6lisG__imgglobal_themeOrange_override",
  "link": "PlasmicHeader-module__d6lisG__link",
  "root": "PlasmicHeader-module__d6lisG__root",
  "rootglobal_themeOrange_override": "PlasmicHeader-module__d6lisG__rootglobal_themeOrange_override",
  "rootglobal_themePurpleDark_override": "PlasmicHeader-module__d6lisG__rootglobal_themePurpleDark_override",
});
